import * as React from "react";
import { useEffect, useState } from "react";
import { PensionArrangementAction } from "../Action/PensionArrangementValuationAction";
import { PensionPathwayInvestmentOption } from "../../../../../../../../Wrap/Constants/Enums/PensionPathwayInvestmentOption";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";

interface IProductOverviewInvestmentPathwaysProps {
    subAccountHierarchyId: string;
}

export const ProductOverviewInvestmentPathways = (props: IProductOverviewInvestmentPathwaysProps) => {
    const [investmentPathwaysData, setInvestmentPathwaysData] = useState(null);

    useEffect(() => {
        if (!investmentPathwaysData) {
            PensionArrangementAction.GetDrawdownInvestmentStrategy(props.subAccountHierarchyId, (data) => {
                setInvestmentPathwaysData(data);
            });
        }
        return () => {
            setInvestmentPathwaysData(null);
        };
    }, []);

    return (
        <>
            <h2 className="mb-36">Investments pathways</h2>
            {investmentPathwaysData == null &&
                <Alert
                    alertType={AlertType.Warning}
                    message={"No data held"}
                />
            }
            {investmentPathwaysData != null &&
                <div className="panel-subtle pt-10 pb-10">
                    <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted">
                        <tbody>
                            <tr>
                                <th scope="row" style={{ width: "50%" }}>Personal Recommendation?</th>
                                <td className="cell-left">{investmentPathwaysData?.PersonalRecommendation ? "Yes" : "No"}</td>
                            </tr>
                            <tr>
                                <th scope="row" style={{ width: "50%" }}>Investment Pathway Selected? </th>
                                <td className="cell-left">{investmentPathwaysData?.InvestmentOption == PensionPathwayInvestmentOption.InvestmentPathway ? "Yes" : "No"}</td>
                            </tr>
                            <tr>
                                <th scope="row" style={{ width: "50%" }}>Investment Pathway Choice:</th>
                                <td className="cell-left">{investmentPathwaysData?.SelectedPathwayId > 0 ? investmentPathwaysData.SelectedPathway.AdditionalText : "N/A"}</td>
                            </tr>
                            <tr>
                                <th scope="row" style={{ width: "50%" }}>Date of last investment pathway response:</th>
                                <td className="cell-left">
                                    {investmentPathwaysData == null ? 'N/A' :
                                        investmentPathwaysData?.EffectiveStartDate
                                            ? JsonDateParser.getFormatDateString(
                                                new Date(investmentPathwaysData?.EffectiveStartDate), "dd/MM/yyyy")
                                            : "N/A"
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
        </>
    );
};
